import { PlaidEntryPointInput, PlaidProduct } from '@varo/graphql-schema-types';
import { PlaidMarketingConsentEntryPoint } from 'features/plaid/hooks/useHasPlaidMarketingConsent';
import { PlaidIntent, PlaidLinkIntent } from 'shared/hooks/usePlaidV2/types';

export type PlaidLinkOrigin = {
  entryPoint: PlaidEntryPointInput;
  product: PlaidProduct;
  sourceName: string;
};

const toPlaidLinkIntent = (origin: PlaidLinkOrigin): PlaidLinkIntent => ({
  intent: PlaidIntent.Link,
  product: origin.product,
  entryPoint: origin.entryPoint,
});

export const PLAID_LINK_ORIGINS = {
  [PlaidMarketingConsentEntryPoint.Home]: {
    entryPoint: PlaidEntryPointInput.Homepage,
    product: PlaidProduct.Transactions,
    sourceName: 'home_for_you',
  },
  [PlaidMarketingConsentEntryPoint.LinkedAccounts]: {
    entryPoint: PlaidEntryPointInput.ExternalAccountManagement,
    product: PlaidProduct.Transactions,
    sourceName: 'external_account_management',
  },
  [PlaidMarketingConsentEntryPoint.Transfer]: {
    entryPoint: PlaidEntryPointInput.MoveMoney,
    product: PlaidProduct.Auth,
    sourceName: 'move_money_transfer',
  },
} as const satisfies Record<PlaidMarketingConsentEntryPoint, PlaidLinkOrigin>;

// Built once so every surface hands usePlaidV2 a stable intent identity.
export const PLAID_LINK_INTENTS: Record<
  PlaidMarketingConsentEntryPoint,
  PlaidLinkIntent
> = {
  [PlaidMarketingConsentEntryPoint.Home]: toPlaidLinkIntent(
    PLAID_LINK_ORIGINS[PlaidMarketingConsentEntryPoint.Home],
  ),
  [PlaidMarketingConsentEntryPoint.LinkedAccounts]: toPlaidLinkIntent(
    PLAID_LINK_ORIGINS[PlaidMarketingConsentEntryPoint.LinkedAccounts],
  ),
  [PlaidMarketingConsentEntryPoint.Transfer]: toPlaidLinkIntent(
    PLAID_LINK_ORIGINS[PlaidMarketingConsentEntryPoint.Transfer],
  ),
};
